import React from 'react'

interface YouTubeEmbedProps {
  youTubeId: string
  autoPlay?: boolean
  containerClassName?: string
  iframeClassName?: string
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({
  youTubeId,
  autoPlay = false,
  containerClassName = '',
  iframeClassName = '',
}) => {
  // Use privacy-enhanced YouTube embed URL to avoid cookie issues
  const embedUrl = `https://www.youtube-nocookie.com/embed/${youTubeId}?${
    autoPlay ? 'autoplay=1&' : ''
  }rel=0&modestbranding=1`

  return (
    <div
      className={`w-full relative mt-10 mb-60 sm:mb-120 ${containerClassName}`}
    >
      <iframe
        src={embedUrl}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        className={`absolute top-0 left-0 w-full h-full min-h-52 sm:min-h-[400px] ${iframeClassName}`}
      />
    </div>
  )
}

export default YouTubeEmbed
